import { useParams } from 'react-router-dom'

/**
 * Returns the base path for admin navigation links.
 * Must be used within a `/:tenantSlug/*` route.
 */
export function useBasePath(): string {
  const { tenantSlug } = useParams<{ tenantSlug: string }>()
  if (!tenantSlug) throw new Error('useBasePath must be used within a /:tenantSlug/* route')
  return `/${tenantSlug}`
}
